<template>
  <div class="c-accordion c-accordion--project-managers">
    <slot name="buttonlabel"></slot>
    <button
      class="c-accordion__button"
      v-bind:class="[isOpen ? activeClass : 'is-active']"
      v-on:click.prevent="toggleContent"
    >
      <svg
        class="c-accordion__icon"
        v-bind:class="[isOpen ? activeClass : 'is-active']"
        width="40"
        height="12"
      >
        <polyline points="12,2 20,10 28,2" stroke-width="3" fill="none" />
      </svg>
    </button>

    <transition name="u-fade">
      <div class="c-accordion__content u-extra-small-margin--top" v-show="isOpen">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "accordionPMList",
  data() {
    return {
      activeClass: "",
      isOpen: false
    };
  },
  methods: {
    toggleContent: function() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>